function convertUSDPriceToString(usdPrice, trailingDecimals = 2) {

    return `$${(usdPrice / 100).toFixed(trailingDecimals)}`;

}

function dispatchGlobalEvent(eventName, content) {

    window.dispatchEvent(new CustomEvent(eventName, {detail: content}));

}

async function compressStringWithGZIP(stringToCompress) {

    const compressedJsonBlob = await new Response(new Blob([stringToCompress]).stream().pipeThrough(new CompressionStream('gzip'))).blob();
    const arrayBuffer = await compressedJsonBlob.arrayBuffer();
    return btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)));

}

async function decompressStringWithGZIP(compressedString) {

    const binaryString = atob(compressedString);
    const bytes = new Uint8Array(binaryString.length);

    for (let index = 0; index < binaryString.length; index++) {

        bytes[index] = binaryString.charCodeAt(index);

    }

    const decompressedBlob = await new Response(new Blob([bytes]).stream().pipeThrough(new DecompressionStream("gzip")));

    return await decompressedBlob.text();

}

async function sendRequestToJSONEndpoint(endpoint, bodyJSON) {

    try {

        const response = await fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: bodyJSON
        });
        
        return await response.json();

    } catch(error) {

        console.error(`Failed to send request to ${endpoint}.`, error);
        return false;

    }

}

async function fetchResponseFromEndpoint(endpoint) {

    try {
        
        const response = await fetch(endpoint);

        if (!response.ok) {

            throw new Error(`Failed to fetch response from ${endpoint}. Returned status: ${response.status}`);

        }

        return response;

    } catch (error) {

        console.error(`Error fetching response from ${endpoint}.`, error);
        return false;

    }

}

async function fetchJSONFromAPIPage(page) {

    try {
        
        const response = await fetchResponseFromEndpoint(`/pages/api/${page}`);

        if (response === false) {

            throw new Error(`Failed to fetch JSON from /pages/api/${page}.`);

        }

        const returnedHTML = await response.text();
        const jsonElement = new DOMParser().parseFromString(returnedHTML, "text/html").getElementById("result");
        
        if (!jsonElement) {

            throw new Error("Failed to parse JSON element.");

        }
        
        return JSON.parse(jsonElement.textContent);

    } catch (error) {

        console.error("Error fetching JSON.", error);
        
    }

}